module.exports = __webpack_public_path__ + "static/img/dengyunze.f12f2c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/dengyunze.jpg
// module id = lBTE
// module chunks = 0